export default "__VITE_ASSET__LT1Gd9mK__"